import { Typography } from "@material-ui/core";
import React from "react";

const NoWorkflowConfigured = ({ isLoading = false, isError = false }) => {
  const showAppropriateTextBasedOnState = () => {
    let text = `Workflow hasn't been configured with form items yet. Please go
        ahead to configure your workflow.`;

    if (isLoading) {
      text = "Loading. Please wait...";
    }

    if (isError) {
      text = "Something went wrong, Please try again later.";
    }

    return text;
  };

  return (
    <div>
      <Typography
        style={{
          fontFamily: " Avenir",
          fontSize: "14px",
          fontWeight: 500,
          color: "#858585",
          textAlign: "center",
          paddingTop: "10px",
        }}
      >
        {showAppropriateTextBasedOnState()}
      </Typography>
    </div>
  );
};

export default NoWorkflowConfigured;
